$(document).ready(function() {
  $(document).on('click', '.specialists-client-list-component .table-buttons.mapping-info-btn', function() {
    if ($(this).hasClass('disabled-btn')) return;

    const mappingInfoModal = $(this).closest('td').find('.mapping-info-modal');
    mappingInfoModal.modal('show');
  });

  $(document).on('change', '.specialists-client-list-component .change-specialist-drop-down-js', function () {
    const form = $(this).find('form');
    // Submit form
    form[0].requestSubmit();
  });

  $(document).on('click', '.specialists-client-list-component .search-icon', function() {
    const hiddenSearchField = $(this).closest('.component').find('.hidden-search-field')
    const hiddenSubmitIcon = $(this).closest('.component').find('.search-icon-submit-button')
    const regularSearchIcon = $(this).closest('.component').find('.search-icon')

    if (hiddenSearchField.hasClass('d-none')) {
      hiddenSearchField.removeClass('d-none');
      hiddenSubmitIcon.removeClass('d-none');
      regularSearchIcon.addClass('d-none');
    }
    else {
      hiddenSearchField.addClass('d-none');
      hiddenSubmitIcon.addClass('d-none');
      regularSearchIcon.removeClass('d-none');
    }
  });

  $(document).on('click', '.brand-territory-check-info-modal-js', function() {
    $.get(`${$(this).attr('path')}`).done(function(html) {
      const myModal = $('#brand-territory-check-info-modal')
      myModal.find('.modal-body').html(html)
      myModal.modal('show');
    });
  });

  $(document).on('click', '.specialists-client-list-component .table-buttons.multiple-inquired-brands', function() {
    if ($(this).hasClass('disabled-btn')) return;

    const chooseTCheckInfoModal = $(this).closest('td').find('.choose-t-check-info-modal');
    chooseTCheckInfoModal.modal('show');
  });
})